// extracted by mini-css-extract-plugin
export var actions = "_2h-0";
export var actionsContainer = "_2h-7";
export var border = "_2h-1";
export var childFullHeight = "_2h-f";
export var collapse = "_2h-2";
export var content = "_2h-a";
export var contentChild = "_2h-e";
export var fullscreen = "_2h-c";
export var hasLeftRadius = "_2h-k";
export var headerContainer = "_2h-3";
export var headerRow = "_2h-5";
export var hidePadding = "_2h-b";
export var navCollapsedGap = "_2h-l";
export var noScrollX = "_2h-m";
export var noScrollY = "_2h-n";
export var noTopPadding = "_2h-i";
export var optOutTopPadding = "_2h-d";
export var pageMain = "_2h-j";
export var pageOuter = "_2h-g";
export var pagePadding = "_2h-8";
export var pageScroll = "_2h-9";
export var profile = "_2h-o";
export var profileContainer = "_2h-p";
export var profileImage = "_2h-q";
export var profileMain = "_2h-r";
export var profileSubtitle = "_2h-t";
export var profileTitle = "_2h-s";
export var showLeftPadding = "_2h-h";
export var tabsPortalSlot = "_2h-6";
export var tabsWrapper = "_2h-4";
export var title = "_2h-u";